import { render, staticRenderFns } from "./ActivixSwitcher.vue?vue&type=template&id=611f38b8&"
import script from "./ActivixSwitcher.vue?vue&type=script&lang=js&"
export * from "./ActivixSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ActivixSwitcher.vue?vue&type=style&index=0&id=611f38b8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports